import { render, staticRenderFns } from "./sales-questions.vue?vue&type=template&id=c5ebe8cc"
import script from "./sales-questions.vue?vue&type=script&lang=js"
export * from "./sales-questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports